import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async create({ commit }, { payload = {}, config = {} }) {
    const data = get(await this.$axios.post(routes.bundle.list(), payload, config), 'data')

    return data
  },
  send({ commit }, { id }) {
    return this.$axios.post(
      routes.bundle.send(id),
      {},
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
  },
  publicLink({ commit }, { id, payload }) {
    return this.$axios.post(routes.bundle.links(id), payload)
  }
}
